export default __webpack_public_path__ + "static/media/Logoverte.0e075553.png";